import { combineReducers } from "redux";
import user from "./user";
import changeUnit from "./unit";
import stateList from "./stateList";
import thingNameContainer from "./locationSpecific";
import usersVendors from "./userVendors";

const rootReducer = combineReducers({
    user,
    changeUnit,
    stateList,
    thingNameContainer,
    usersVendors
});

export default rootReducer;
